import { useTranslation } from 'react-i18next'
import { useThemeFeatures } from '../../../hooks/useThemeFeatures'
import styles from './Signature.module.css'

type SignatureProps = {
  signature: string
}
const Signature = ({ signature }: SignatureProps) => {
  const { t } = useTranslation()
  const themeFeatures = useThemeFeatures()
  return (
    <div>
      <h5 className="text-[var(--caption-text)] text-base font-medium mb-4 text-center">
        {t('betResult.signature')}
      </h5>
      <div className="flex flex-col items-center">
        <div
          className={`inline-flex px-4 py-3 rounded-full border border-[var(--bet-type-active-border)] ${!themeFeatures.yeekeeResultAlignment ? 'btn-active-state' : ''} ${styles.signatureContainer}`}
        >
          <span className="text-[var(--body-text)] text-base font-medium font-mono break-all text-center">
            {signature}
          </span>
        </div>
      </div>
    </div>
  )
}

export default Signature
